import { passwordProblems } from '@wms/domain';

// no 0/O, 1/l/I: the password is read out or typed from a note
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';

/** A temporary password like "Kq7m-Tz4p-Hr8w": easy to pass on, accepted by the password rule. */
export function temporaryPassword(): string {
  for (;;) {
    const bytes = crypto.getRandomValues(new Uint8Array(12));
    const chars = [...bytes].map((b) => ALPHABET[b % ALPHABET.length]!);
    const value = [chars.slice(0, 4), chars.slice(4, 8), chars.slice(8, 12)].map((g) => g.join('')).join('-');
    if (passwordProblems(value).length === 0) return value;
  }
}
